import { IScope, IRootScopeService } from "angular";
import { StateService } from "@uirouter/angularjs";
import { ISubscriptionCancellation, IAccountSubscription } from "../models";
import { AccountService } from "@gtmhub/accounts/accounts-service";
import { SubscriptionService } from "@gtmhub/subscriptions/subscriptionService";
import { IIndicator, UIErrorHandlingService } from "@gtmhub/error-handling";
import { hasCurrentUserRole } from "@gtmhub/users";

interface ICancelSubscriptionIndicators {
  loading: IIndicator;
  canceling: IIndicator;
}

interface ICancelSubscriptionScope extends IScope {
  canCancelSubscription: boolean;
  subscriptionCancellation: ISubscriptionCancellation;
  indicators: ICancelSubscriptionIndicators;
  cancelSubscription();
}

export class CancelSubscriptionCtrl {
  public static $inject = ["AccountService", "$rootScope", "$scope", "$state", "SubscriptionService", "UIErrorHandlingService"];

  constructor(
    private accountService: AccountService,
    private $rootScope: IRootScopeService,
    private $scope: ICancelSubscriptionScope,
    private $state: StateService,
    private subscriptionService: SubscriptionService,
    private uiErrorHandlingService: UIErrorHandlingService
  ) {
    this.$scope.cancelSubscription = this.cancelSubscription;
    this.$scope.indicators = {
      loading: { progress: true },
      canceling: { progress: false },
    };
    this.$scope.subscriptionCancellation = {
      reason: "",
      comment: "",
    };
    this.getAccountSubscription();
  }

  private accountSubscription: IAccountSubscription;

  private getAccountSubscription = (): void => {
    this.accountService.getSubscription().then(
      (accountSubscription: IAccountSubscription) => {
        delete this.$scope.indicators.loading;
        this.accountSubscription = accountSubscription;
        this.$scope.canCancelSubscription = this.canCancelSubscription();
      },
      (error) => this.handleError(error, "loading")
    );
  };

  private cancelSubscription = () => {
    this.$scope.indicators.canceling = { progress: true };

    this.subscriptionService.cancelSubscription(this.$scope.subscriptionCancellation).then(
      () => {
        delete this.$scope.indicators.canceling;
        this.$rootScope.$broadcast("cancelSubscription");

        this.$state.go("^.^");
      },
      (error) => this.handleError(error, "canceling")
    );
  };

  private canCancelSubscription = (): boolean => {
    return hasCurrentUserRole("admin") && this.accountSubscription.allowedCancellation && !this.accountSubscription.hasScheduledCancellation;
  };

  private handleError = <E>(error: E, indicator: string) => {
    this.uiErrorHandlingService.handleIndicator(error, { indicator, inline: true });
  };
}
